<template>
    <div id="editApp" class="app-inner" v-loading="loading"
     element-loading-text="正在提交中..."
     element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
    >
         <div class="public-btn-small flex align-cen posta">
            <div class="public-btn-small-plan"  @click="reback" style="margin-left:0">
                返回
            </div>
            <div class="public-btn-small-primary"  @click="onSubmit('ruleForm')" style="margin-left:16px">
                {{edittext}}
            </div>
            </div> 
            <div class="edit-from">
                  <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-database-fill"></i>  基本信息
            </div>
        </div>
        <el-form ref="ruleForm" :model="form" label-width="100px" :rules="rules" class="flex align-cen">
             <el-form-item label="应用名称：" prop="appName">
                    <el-input v-model="form.appName" placeholder="请输入应用名称【1-50】" clearable></el-input>
                </el-form-item>
                 <el-form-item label="应用分类：" prop="classifyId">
                    <el-cascader
                :options="itemList"
                v-model="form.classifyId"
                 @change="classSelect1"
                separator="--"
                clearable
                ref="cascaderRef"
                 change-on-select
                >
            </el-cascader>
                 </el-form-item>
                     <el-form-item label="应用顶图：" prop="pic">
                    <el-upload
                    class="avatar-uploader"
                    :action="$config.baseUrl + '/admin/sys-file/upload'"
                    :headers="headers"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                    :before-upload="$util.beforeUpload"
                    :disabled="uploadBoolean"
                    >
                    <div slot="tip" class="el-upload__tip" >建议尺寸：<span style="color:#f56c6c">1920*560</span></div>
                    <img :src="form.pic" class="avatar" v-if="form.pic">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                       <!--页面新增删除和预览-->
                    <span v-if="form.pic" class="el-upload-list__item-actions">
                        <span class="upload-icon">
                            <span class="el-uploads-span" style="margin-right: 10px;" @click.stop="oploadImgPre(1)">
                                <i class="el-icon-zoom-in"></i>
                            </span>
                            <span class="el-upload-span" @click.stop="oploadImgDel(1)">
                                <i class="el-icon-delete"></i>
                            </span>
                        </span>
                    </span>
                    <el-dialog :visible.sync="oploadDialogVisible" size="tiny" :append-to-body="true" :show-close="false">
                        <img width="100%" :src="form.pic" alt="">
                    </el-dialog>
                    </el-upload>
                 </el-form-item>
                    <el-form-item label="首页展示：" prop="thumb">
                            <el-upload
                    class="avatar-uploader"
                    :action="$config.baseUrl + '/admin/sys-file/upload'"
                    :headers="headers"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess2"
                    :before-upload="$util.beforeUpload"
                    :disabled="uploadBoolean2"
                    >
                    <div slot="tip" class="el-upload__tip" >建议尺寸：<span style="color:#f56c6c">373*280</span></div>
                    <img :src="form.thumb" class="avatar" v-if="form.thumb">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                       <!--页面新增删除和预览-->
                    <span v-if="form.thumb" class="el-upload-list__item-actions">
                        <span class="upload-icon">
                            <span class="el-uploads-span" style="margin-right: 10px;" @click.stop="oploadImgPre(3)">
                                <i class="el-icon-zoom-in"></i>
                            </span>
                            <span class="el-upload-span" @click.stop="oploadImgDel(3)">
                                <i class="el-icon-delete"></i>
                            </span>
                        </span>
                    </span>
                    <el-dialog :visible.sync="oploadDialogVisible2" size="tiny" :append-to-body="true" :show-close="false">
                        <img width="100%" :src="form.thumb" alt="">
                    </el-dialog>
                    </el-upload>
                    </el-form-item>
                   <el-form-item label="应用描述：" prop="description">
                    <el-input
                        type="textarea"
                        :rows="9"
                        placeholder="使用一句话简单介绍功能【1-50】"
                        minlength="1"
                        maxlength="200"
                        v-model="form.description"
                        clearable
                        >
                        </el-input>
                   </el-form-item>
                   <el-form-item label="应用排序：">
                    <el-input v-model="form.sort" placeholder="请输入排序【非必填】" clearable></el-input>
                </el-form-item>
                <!-- 九图上传 -->
              <div class="el-price-table flex align-cen">
                <div class="table-label">商品图片：</div>
                <div class="moreImg">
                      <el-upload
                    class="avatar-uploaderlogo"
                    :action="$config.baseUrl + '/admin/sys-file/upload'"
                    :headers="headers"
                    list-type="picture-card"
                    :limit="9"
                     :file-list="moreImg"
                     :on-change="handleChange"
                    :before-upload="$util.beforeUpload"
                    :on-exceed="maxLenImg"
                    :on-preview="handlePictureCardPreview"
                    :on-success="handlePictureCardSuccess"
                    :on-remove="handleRemove"
                    >
                     <i class="el-icon-plus"></i>
                     <div class="el-upload__tip" slot="tip">上传商品图片，最多添加9张图片</div>
                      <div slot="tip" class="el-upload__tip" >建议尺寸：<span style="color:#f56c6c">350*350</span></div>
                      </el-upload>
                       <!--  -->
                       <div class="flex flex-w">
                     <div class="moreImg_btn"
                     v-for="(item,index) in moreImg"
                     @click="index != 0 ? setFirst(item,index) : ''"
                     :class="{moreBot:index <=4 && moreImg.length <5,moreTop:index <=4 && moreImg.length >=5,
                     moreBot1:index>4 && moreImg.length>5,
                     moreTop1:index <=4 && moreImg.length >5
                     }"
                      >
                      {{index == 0 ? '商品首图' : '设为首图'}}
                    </div>
                      </div>
                </div>
                   <el-dialog :visible.sync="dialogVisible" size="tiny"  :append-to-body="true">
                      <img width="100%" :src="dialogImageUrl" alt="">
                    </el-dialog>
              </div>
                                            <!-- 视频上传 -->
               <div class="el-price-table el-price-table1 flex align-cen" style="width:100%">
                <div class="table-label">商品视频：</div>
                <div class="videodiv">
                   <el-upload  style="text-align: center;" drag 
                   :action="$config.baseUrl + '/admin/sys-file/upload'" accept="video/*" 
                      :headers="headers" :before-upload="onBeforeUploadVideo" 
                      :on-success="onSuccessVideo" :on-error="onErrorVideo" 
                      :on-progress="uploadVideoProcess"
             :multiple="false">
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              <div class="el-upload__tip" slot="tip">只能上传视频文件，且不超过150M</div>
            </el-upload>
            <div slot="tip" class="el-upload__tip" v-if="form.videoUrl">商品视频地址：<span style="color:#f56c6c">{{form.videoUrl}}</span></div>
                </div>
               </div>
        </el-form>
                    <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-database-fill"></i>  应用设置
            </div>
        </div>
         <el-form ref="ruleForm1" :model="form" label-width="140px" :rules="rules">
             <el-form-item label="版本号：">
                <div>{{form.versionNum}}</div>
             </el-form-item>
              <el-form-item label="应用类型：" prop="type">
                <el-radio v-model="form.type" label="1" >客户端型应用</el-radio>
                <el-radio v-model="form.type" label="2">网页型应用</el-radio>
                 <el-radio v-model="form.type" label="3">展示型应用</el-radio>
              </el-form-item>
               <el-form-item label="上传应用包：" :prop="!$route.query.id  ? 'resourceUrl': ''"  v-if="form.type == 1">
                    <el-upload
                    class="avatar-uploader"
                    :action="uploadUrl"
                    :headers="headers"
                    :data="dataObj"
                    accept=".7z,.rar,.zip"
                    drag
                    :file-list="fileList"
                    :on-change="handleChangePic"
                    :disabled="$route.query.id ? true : false"
                    :on-error="uploadError"
                    :on-remove="handleRemove1"
                    :before-upload="beforeUploadFun"
                    :on-success="handleAvatarSuccess1"
                    >
                     <i class="el-icon-upload" ></i>
                     <div class="el-upload__text" v-if="!$route.query.id ">将文件拖到此处，或<em>点击上传</em></div>
                      <div class="el-upload__text" v-if="$route.query.id ">请在版本里新增或者回退</div>
                     <div slot="tip" class="el-upload__tip" v-if="!$route.query.id ">支持格式：<span style="color:#f56c6c">rar、zip、7z</span></div>
                     <!-- 进度条 -->
                     <!-- <div class="proMask flex align-cen justify-content-cen" v-if="progressFlag1">
                      <el-progress type="circle" :percentage="loadProgress1"></el-progress>
                     </div>
                     <div slot="tip" class="el-upload__tip">
                      <ul class="el-upload-list el-upload-list--text">
                        <li class="el-upload-list item is-success flex align-cen" v-for="(item,index) in fileList" :key="index"
                        style="width:100%;margin-top:10px;float:left;margin-right: 5%">
                      <a class="el-upload-list item-name" style="width:93%">
                            <i class="el-icon-document">
                            </i>
                            {{item.name}}
                            </a>
                         <label class="el-upload-list item-status-label mft">
                          <i v-if="item.status== 'uploading'"><i class="el-icon-loading" style="color: #36a3f7"></i></i>
                          <i v-else-if="item.status == 'success' || item.url "> <i class="el-icon-circle-check" style="color:#67c23a"></i> </i>
                           <i v-else-if="item.status== 'warning'"><i class="el-icon-circle-close" style="color: red"></i></i>
                      </label>
                      <i class="el-icon-close mft" @click="handleRemove1('',fileList)"></i>
                      </li>
                      </ul>
                     </div> -->
                     <div slot="tip" class="el-upload__tip" v-if="dowloadShow">应用包下载地址：<span style="color:#f56c6c">{{dowloadUrl || form.resourceUrl}}</span></div>
                    </el-upload>
               </el-form-item>
                 <el-form-item label="客户端LOGO："   v-if="form.type == 1">
                    <el-upload
                    class="avatar-uploaderlogo"
                    :action="$config.baseUrl + '/admin/sys-file/upload'"
                    :headers="headers"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess3"
                    :before-upload="$util.beforeUpload"
                    :disabled="uploadBoolean1"

                    >
                    <div slot="tip" class="el-upload__tip" >建议尺寸：<span style="color:#f56c6c">80*80</span></div>
                    <img :src="form.logoUrl" class="avatar" v-if="form.logoUrl">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                       <!--页面新增删除和预览-->
                    <span v-if="form.logoUrl" class="el-upload-list__item-actions">
                        <span class="upload-icon">
                            <span class="el-uploads-span" style="margin-right: 10px;" @click.stop="oploadImgPre(2)">
                                <i class="el-icon-zoom-in"></i>
                            </span>
                            <span class="el-upload-span" @click.stop="oploadImgDel(2)">
                                <i class="el-icon-delete"></i>
                            </span>
                        </span>
                    </span>
                    <el-dialog :visible.sync="oploadDialogVisible1" size="tiny" :append-to-body="true" :show-close="false">
                        <img width="100%" :src="form.logoUrl" alt="">
                    </el-dialog>
                    </el-upload>
                 </el-form-item>
                <el-form-item label="应用地址：" prop="resourceUrl" v-if="form.type == 2">
                      <el-input v-model="form.resourceUrl" placeholder="请输入应用地址" clearable></el-input>
                </el-form-item>
                   <el-form-item label="应用地址："  v-if="form.type == 3">
                      <el-input v-model="form.resourceUrl" placeholder="请输入应用地址" clearable></el-input>
                </el-form-item>
                 <el-form-item label="客户端下载资源：" :prop="form.type == 1 ? 'clientDownload' : ''" v-if="form.type == 1">
                <el-radio v-model="form.clientDownload" label="1" >跟随一级分类</el-radio>
                <el-radio v-model="form.clientDownload" label="0">下载本应用</el-radio>
              </el-form-item>
         </el-form>
         <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-database-fill"></i>  规格信息
            </div>
        </div>
         <el-form ref="ruleForm2" :model="form" label-width="140px" :rules="rules">
              <el-form-item label="付费类型：" prop="payType">
                <el-radio v-model="form.payType" label="1"  >免费</el-radio>
                <el-radio v-model="form.payType" label="2" >付费</el-radio>
              </el-form-item>
                <el-form-item label="付费模式：" :prop="form.payType == 2 ? 'payModel' : ''"  v-if="form.payType == 2">
                <el-radio v-model="form.payModel" label="1"  @change="priceChange">时长制</el-radio>
                <el-radio v-model="form.payModel" label="2" @change="priceChange">面议付费</el-radio>
              </el-form-item> 
              <!-- 选择买断制 -->
              <!-- <div v-for="(item, i) in form.appSkuList">
                <el-form-item label="买断原价：" :prop="form.payModel == 2 ? 'appSkuList.'+ i +'.originalPrice' : ''" v-if="form.payType == 2 && form.payModel == 2"
               :rules="rules1.originalPrice"
               >
                    <el-input v-model="item.originalPrice" placeholder="请输入买断原价" clearable
                     maxlength="9"
                      minlength="1"
                    >
                      <template slot="append">元</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="买断价格：" :prop="form.payModel == 2 ? 'appSkuList.' + i + '.salePrice' : ''" v-if="form.payType == 2 && form.payModel == 2"
                :rules="rules1.salePrice"
                >
                    <el-input v-model="item.salePrice" placeholder="请输入买断价格" clearable
                     maxlength="9"
                          minlength="1"
                    >
                      <template slot="append">元</template>
                    </el-input>
                </el-form-item>
              </div> -->
              <!-- 选择时长制 -->
              <div class="el-price-table flex align-cen" v-if="form.payType == 2 && form.payModel == 1">
                <div class="table-label">时长制售价规格：</div>
                 <div class="table-con">
                        <el-table
                      :data="form.appSkuList"
                      border
                      style="width: 100%"
                      >
                      <el-table-column label="套餐名称" align="center" width="220px">
                        <template slot-scope="scope">
                          <el-input v-model="scope.row.name" placeholder="请输入套餐名称【1-30】" clearable
                          maxlength="30"
                          minlength="1"
                          >
                          </el-input>
                        </template>
                       </el-table-column>
                       <el-table-column label="使用期限（月）" align="center" width="170px"
                       >
                        <template slot-scope="scope">
                          <el-input v-model="scope.row.deadline" placeholder="请输入使用期限" clearable
                           maxlength="4"
                           minlength="1"
                          ></el-input>
                        </template>
                       </el-table-column>
                        <el-table-column label="支撑账号个数" align="center" width="200px"
                        >
                        <template slot-scope="scope">
                          <el-input v-model="scope.row.accountNum" placeholder="不输则视为无限制" clearable
                          oninput="value=value.replace(/[^\d]/g,'')"
                           maxlength="5"
                           minlength="1"
                          ></el-input>
                        </template>
                       </el-table-column>
                       <el-table-column label="原价（元）" align="center" width="150px">
                        <template slot-scope="scope">
                          <el-input v-model="scope.row.originalPrice" placeholder="请输入原价" clearable
                           oninput="value=value.replace(/^[^\d.]+/g,'')"
                          maxlength="9"
                          minlength="1"
                          ></el-input>
                        </template>
                       </el-table-column>
                        <el-table-column label="现价（元）" align="center" width="150px">
                        <template slot-scope="scope">
                          <el-input v-model="scope.row.salePrice" placeholder="请输入现价" clearable
                           oninput="value=value.replace(/^[^\d.]+/g,'')"
                           maxlength="9"
                          minlength="1"
                          ></el-input>
                        </template>
                       </el-table-column>
                       <el-table-column label="操作" align="center" width="150px">
                        <template slot-scope="scope">
                         <el-button type="text" size="small" style="color:red" @click.stop="deltab(scope.row)">删除</el-button>
                        </template>
                       </el-table-column>
                        </el-table>
                     <div class="addtab">
                     <div class="public-btn-small" style="padding:0;width:140px;margin-top:20px">
                     <div class="public-btn-small-primary" @click="addtab">
                          添加规格        
                    </div>
                </div>
                  </div> 
                  </div>
              </div>
             
         </el-form>
        <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-database-fill"></i>  关联产品
            </div>
                <div class="mft public-btn-small">
                     <div class="public-btn-small-primary" @click="openBl">
                          关联相关应用          
                    </div>
                </div>
        </div>

        <div class="App-tab">
                  <el-table
            :data="relationList"
            border
            style="width: 100%"
            :header-cell-style="{background:'#f7f8fa',color:'#333'}"
            >
           <el-table-column label="应用图片" align="center">
            <template slot-scope="scope">
                <img :src="scope.row.pic ? scope.row.pic : ''" alt="" style="display: block;width:50%;margin:0 auto">
            </template>
         </el-table-column>
         <el-table-column label="应用ID" align="center" :prop=" isShowId ? 'relatedAppId' : 'id'">
         </el-table-column>
          <el-table-column label="应用名称" align="center" prop="appName">
         </el-table-column>
            <el-table-column label="应用类型" align="center" >
            <template slot-scope="scope">
                <span>{{scope.row.type == 1 ? '客户端应用':'网页型应用'}}</span>
            </template>
         </el-table-column>
          <el-table-column label="应用分类" align="center" prop="classifyName">
         </el-table-column>
          <el-table-column label="最新版本号" align="center" prop="versionNum">
         </el-table-column>
             <el-table-column
            fixed="right"
            label="操作"
            align="center"
            >
             <template slot-scope="scope">
            <el-button type="text" size="small" style="color:red" @click.stop="deletPro(scope.row)">删除</el-button>
             </template>
             </el-table-column>
         </el-table>
        </div>
            <div class="public-tit flex align-cen" id="addCanvas" v-if="platformAppContentList.length == 0">
            <div class="public-tit-list">
                <i class="icon-al-database-fill"></i>  页面分类
            </div>
               <div class="mft public-btn-small">
                     <div class="public-btn-small-primary"
                     @click="addCanvas(-1)"
                     >
                          添加分类  
                    </div>
                </div>
        </div>
                <div class="AppContent">
                    <div class="moreCanvas"
                     v-for="(item,index) in platformAppContentList"
                    :key="index"
                    :id="'addCanvas'+index"
                    >
                            <div class="public-tit flex align-cen" style="margin-bottom:20px">
                        <div class="public-tit-list">
                            <i class="icon-al-database-fill"></i> 分类{{index+1}}
                        </div>
                    </div>
                             <div class="businessList-filter-list flex align-cen">
                        <div class="fl-le flex align-cen">
                    <div class="label">分类标题：</div>
                    <div class="el-select1">
                        <el-input placeholder="请输入分类标题【1-5】" v-model="item.title" clearable
                        maxlength="5"
                        > </el-input>
                    </div>
                    </div>
                        <div class="fl-rt flex align-cen">
                    <div class="label">副标题：</div>
                    <div class="el-select1">
                    <el-input placeholder="请输入副标题【1-50】" v-model="item.subhead" clearable maxlength="50"> </el-input>
                    </div>
                    </div>
                    <div class="mft deletBtn"
                    @click="deletCanvas(item)"
                    >
                    删除分类
                    </div>
                    <div class="mft public-btn-small" style="padding-left:0" v-if="index == platformAppContentList.length-1">
                     <div class="public-btn-small-primary"
                     @click="addCanvas(index+1)"
                     >
                          添加分类  
                    </div>
                </div>
                </div>
                  <quillsTemplate  @sendStatus="emitFun" :propData="item.content"
                      :currindex="index"
                    :ref="'quillTemplate' + index"
                    ></quillsTemplate>
        </div>
                  
              </div> 
            </div>
            <!-- 选择应用弹框 -->
     <el-dialog
  title="选择相关应用"
  :visible.sync="centerDialogVisible"
  width="80%"
  :append-to-body="true"
  center
  v-if="centerDialogVisible"
  @close="reback1(0)"
  >
  <div class="forminfo"> 
    <appTemplate :selectType='centerDialogVisible'
    :authType='2'
    :bussID='$route.query.id'
    :isAppId="isShowId"
    @sendStatus="classSelect"
    ref="appTemplate"
    ></appTemplate>
       <div class="authbtn flex align-cen">
             <el-button plain @click="reback1(0)">取消</el-button>
              <el-button type="primary" class="mft" @click="onSubmit1">确认选择</el-button>
        </div>
  </div>
     </el-dialog>
    </div>
</template>
<script>
import  Format from "../../../utils/auth.js"  
import { getApplicationTypeList, editApplication, AppDetail,policy} from "@/api/index/index"  //应用分类、新增应用、应用详情、获取签名
import LocaStorage from "../../../utils/localstorage.js" //本地存储公共方法
import appTemplate from "@/views/Application/index.vue"; //将应用列表页面作为组件使用
import { quillEditor } from "vue-quill-editor";  //富文本编辑器
import debounce from '../../../utils/debounce.js' //防抖
import quillsTemplate from "@/components/quills";  //多富文本组件
export default {
    name:'editApp',
    components:{
        appTemplate,
        quillEditor,
        quillsTemplate
    },
    data(){ 
        let _self = this;
        return {
          uploadUrl:'',
          dataObj:{
            policy:'',
            signature:'',
            ossaccessKeyId:'',
            key:'',
            dir:'',
            host:'',
            callback:''
          },
           isShowId:false,
          loading:false,
            nowIndex:0,
            dowloadShow:false,
            qillInit: true,
            imgsrc:'',
            quillUpdateImg: false,
            dowloadUrl:'',
            centerDialogVisible:false,
            edittext:'保存',
            itemList:[],
            headers:{},
            uploadBoolean:false,
            uploadBoolean1:false,
            uploadBoolean2:false,
            oploadDialogVisible:false,
            oploadDialogVisible1:false,
            oploadDialogVisible2:false,
            progressFlag:false,
             loadProgress: 0, // 动态显示进度条
             loadProgress1:0,
             fileList: [],
             relationList:[],
             selectList:[],
             platformAppContentList:[
             ],
             platformAppRelationList:[],
            form:{
                sort:'',
                appName:'',
                classifyId:'',
                pic:'',
                thumb:'',
                description:'',
                versionNum:'1.0',
                type:'',
                resourceUrl:'',
                clientDownload:'',
                logoUrl:'',
                payType:'',
                payModel:'',
                appSkuList:[
                  {
                    name:'',
                    originalPrice:'',
                    salePrice:'',
                    deadline:'',
                    accountNum:'',
                  }
                ],
                appImagesList:[],
                videoUrl:''
            },
            scrollTop:'',
            rules:{
                 appName: [
                     {
                        trigger: "blur",
                        message:'请输入应用名称',
                        required: true, 
                     },
                      { min: 1, max: 50, message: '请输入符合规则的应用名称', trigger: 'blur' }
                 ],
                 classifyId: [{ required: true, message: '请选择应用分类', trigger: 'change' }],
                 pic:[{ required: true, message: '请上传应用顶图', trigger: 'blur' }],
                 thumb:[{ required: true, message: '请上传应用封面图', trigger: 'blur' }],
                 description:[
                  { required: true, message: '请输入描述', trigger: 'blur' },
                { min: 1, max: 50, message: '应用描述超出长度', trigger: 'blur' }
                 ],
                 type:[{ required: true, message: '请选择类型', trigger: 'blur' }],
                 resourceUrl:[{ required: true, message: '必填项', trigger: 'blur' }],
                 logoUrl:[{ required: true, message: '必填项', trigger: 'blur' }],
                 clientDownload:[{ required: true, message: '请选择', trigger: 'blur' }],
                 payType:[{ required: true, message: '请选择付费类型', trigger: 'blur' }],
                 payModel:[{ required: true, message: '请选择付费模式', trigger: 'blur' }],
            },
            rules1:{
              originalPrice:[{ required: true, message: '请输入买断原价', trigger: 'blur' },
                {
                        validator: Format.FormValidate.Form().Psd,   //validator： 自定义验证规则
                        trigger: "blur",
                        message:'请输入数字',
                        required: true, 
                }
              ],
               salePrice:[{ required: true, message: '请输入买断价格', trigger: 'blur' },
                {
                        validator: Format.FormValidate.Form().Psd,   //validator： 自定义验证规则
                        trigger: "blur",
                        message:'请输入数字',
                        required: true, 
                }
               ],
            },
            dialogImageUrl: '',
            dialogVisible: false,
            moreImg:[],
            progressFlag1:false,
            loadStatus:''
        }
    },
     beforeCreate(){
     
  },
    created(){      
        this.getthisType()
         let token = LocaStorage.setAge().get('token')
        if(token){
            this.headers = {
                'Authorization': token
            }
        }
        if(this.$route.query.id){
            this.$route.meta.title = "修改应用"
            this.edittext = "修改"
            this.dowloadShow = true
            this.getDetail()
        }else{
             this.dowloadShow = false
            this.$route.meta.title = "新增应用" 
             this.edittext = "保存"
        }
    },
    mounted(){
               window.onbeforeunload = e => {
            e = e || window.event
            if (e) {
                e.returnValue = '关闭提示'
            }
           return '关闭提示'
        }
    },
    methods: {
          // 子组件触发的方法
        emitFun(val,index){
            this.platformAppContentList[index].content = val
        },
      setFirst(data,index){
        // 先删除数组当前项、再通过unshift函数讲当前数据放在第一位
        this.moreImg.splice(index,1)
        this.moreImg.unshift(data)
      },
      // 视频上传成功钩子
        onSuccessVideo (res) {
      if (res.code == 0) {
        this.form.videoUrl = res.data.url
      } else {
        this.$message.error(res.msg)
      }
    },
       // 文件上传失败时的钩子
    onErrorVideo () {
      this.$message.error('上传失败')
    },
            // el-文件上传组件
    onBeforeUploadVideo (file) {
      let acceptArr = [
          "video/mp4",
          "video/ogg",
          "video/flv",
          "video/avi",
          "video/wmv",
          "video/rmvb",
        ]
      const isVideo = acceptArr.includes(file.type)
      
      const isLt1M = file.size / 1024 / 1024 < 150
      if (!isVideo) {
        this.$message.error("请上传正确的视频格式")
      }
      if (!isLt1M) {
        setTimeout( () => {this.$message.error('上传文件大小不能超过 150MB!')}, 10) 
        
      }
      return isLt1M && isVideo
    },
       // 视频上传进度
      uploadVideoProcess(event, file, fileList) {
          this.progressFlag = true; // 显示进度条
          this.loadProgress = parseInt(event.percent); // 动态获取文件上传进度
          if (this.loadProgress >= 100) {
              this.loadProgress = 100
              setTimeout( () => {this.progressFlag = false}, 1000) // 一秒后关闭进度条
          }
      },
      progressFun(event, file, fileList){
        this.progressFlag1 = true; // 显示进度条
        this.loadProgress1 = parseInt(event.percent); // 动态获取文件上传进度
        if (this.loadProgress1 >= 100) {
              this.loadProgress1 = 100
          }
      },
      // 多图上传
      handleChange(file, fileList){
        this.moreImg = fileList.slice(-9);
      },
      // 多图移除
      handleRemove(file, fileList){
      this.moreImg = fileList.slice(-9);
      },
      // 多图上传成功
      handlePictureCardSuccess(file, fileList){
      },
      // 多图预览
       handlePictureCardPreview(file) {
        if(file.imgUrl){
          this.dialogImageUrl = file.imgUrl;
        }else{
          this.dialogImageUrl = file.url
        }
        this.dialogVisible = true;
      },
      // 文件上传超过最大个数
      maxLenImg(){
       this.$message.error('最多添加9张商品图片')
      },
      // 付费模式改变
      priceChange(){
        if(this.form.payModel == 2){
          this.form.appSkuList = []
        }
      },
      // 添加规格
      addtab(){
        if(this.form.appSkuList.length > 4){
          return this.$message.error('最多只能添加5个')
        }else{
           this.form.appSkuList.push({
          name:'',
          originalPrice:'',
          salePrice:'',
          deadline:'',
          accountNum:'',
        })
        }
      },
      // 规格删除
      deltab(data){
           let arr = []
          arr.push(data)
        let delet= this.form.appSkuList.filter(item=>!arr.some(ele=>ele===item)) 
        if(this.form.appSkuList.length == 1){
          this.$message.error('需保留一个')
        }else{
          this.form.appSkuList= delet
        }
         
      },
        // 获取应用详情
         getDetail(){
                 AppDetail({
                id:this.$route.query.id
              })
            .then(res => {
             this.form = {
                    sort:res.data.sort || '',
                    appName:res.data.appName,
                    classifyId:res.data.classifyId,
                    pic:res.data.pic,
                    thumb:res.data.thumb,
                    type:res.data.type,
                    description:res.data.description,
                    clientDownload:res.data.clientDownload,
                    versionNum:res.data.versionNum,
                    resourceUrl:res.data.resourceUrl,
                    logoUrl:res.data.logoUrl,
                    payType:res.data.payType,
                    payModel:res.data.payType == 2 ? res.data.payModel : '',
                    videoUrl:res.data.videoUrl,
                    appSkuList:res.data.appSkuList ? res.data.appSkuList : [{ name:'', originalPrice:'', salePrice:'',deadline:'',accountNum:''}]
                }
                if(this.$route.query.id) this.isShowId = true
                this.dowloadUrl = res.data.downloadUrl
                this.relationList = res.data.platformAppRelationList
                this.platformAppContentList = res.data.platformAppContentList || []
             for (const key in res.data.appImagesList) {
              this.moreImg.push({
                url:res.data.appImagesList[key].imgUrl,
                response:{
                  data:{
                    url:res.data.appImagesList[key].imgUrl
                  }
                }
              })
            }   
            })
            .catch(err => {
            })
         },
         classSelect1(value){
             if(value){
                let index = value.length-1
                this.form.classifyId = value[index]
            }
         },
        // 删除分类
        deletCanvas(data){
            let arr = []
            arr.push(data)
        let delet= this.platformAppContentList.filter(item=>!arr.some(ele=>ele ===item)) 
       this.platformAppContentList = delet
        this.nowIndex == 0 ?  this.nowIndex = 0 : this.nowIndex = this.nowIndex -1
        },
        // 添加分类
        addCanvas(index){
            if(index>=0){
                this.nowIndex=index
            }else{
                this.nowIndex=0
            }
            this.platformAppContentList.push({
                title:'',
                subhead:'',
                content:''
            })
        },
        // 删除
        deletPro(data){
              let arr = []
            arr.push(data)
        let delet= this.relationList.filter(item=>!arr.some(ele=>ele.id===item.id)) 
         this.relationList = delet
        //   this.$refs.appTemplate.editfun(this.relationList) 
        },
        // 取消选择
        reback1(){
            this.$refs.appTemplate.remove()  
            if(this.$route.query.id) this.isShowId = true
             this.centerDialogVisible = false  
        },
        // 确认选择
        onSubmit1(){
          // 过滤数组中的对象，去除重复项  
                let uniqueObjects = this.selectList.filter((item, index) => {  
                  // 如果是对象，则进行去重逻辑  
                  if (typeof item === 'object' && item !== null) {  
                    // 使用 findIndex 查找数组中是否存在相同的对象  
                    return this.selectList.findIndex(otherItem => JSON.stringify(item) === JSON.stringify(otherItem)) === index;  
                  }  
                  // 如果不是对象，则直接返回 true，因为非对象元素不会重复  
                  return true;  
                });  
            this.relationList = uniqueObjects
           this.centerDialogVisible = false
        }, 
        // 表格选择
        classSelect(val,val1){
           this.selectList = val
           this.isShowId = val1
        },
        openBl(){
             this.centerDialogVisible = true  
            //  console.log(this.relationList)   
                     this.$nextTick(function () {   
                 this.$refs.appTemplate.editfun(this.relationList)    
             })
            
           
        },
         handleChangePic(file,fileList){
       if (fileList.length > 0) {
                     this.fileList = [fileList[fileList.length - 1]]  // 这一步，是 展示最后一次选择的csv文件
                 }
 },

        // 获取应用分类
           getthisType(){
            this.itemList = []
             getApplicationTypeList({
                name:''
             })
            .then(res => {
              if(res.data !==null){
                for (const key in res.data) {
                  this.itemList.push({
                    value:res.data[key].id,
                    label:res.data[key].name,
                    children:res.data[key].children ? [] : ''
                  }) 
                  if(res.data[key].children){
                    for (const i in res.data[key].children) {
                        this.itemList[key].children.push({
                            value:res.data[key].children[i].id,
                            label:res.data[key].children[i].name
                        })
                    }
                  } 
                }
              }else{
                    this.itemList = []
             }

            })
            .catch(err => {
            })
        },
        // 返回
        reback(){
            this.$router.push("/Application")
        },
        // 保存
        onSubmit(formName){
            this.form.appImagesList = []
             this.platformAppRelationList = []
            for (const key in this.relationList) {
                this.platformAppRelationList.push(
                     {
                        relatedAppId:this.relationList[key].payType ? this.relationList[key].id : this.relationList[key].relatedAppId
                    }
                )
            }
            for (const key in this.moreImg) {
              this.form.appImagesList.push({
                imgUrl:this.moreImg[key].response.data.url,
                imgSort:parseInt(Number(key)+1),
                defaultFlag:key==0 ? 1 : 0
              })
            }
            let params = { ...this.form};
            let method = "post"
            let appSkuList = this.form.appSkuList
            if(!this.$route.query.id) params = {...this.form,platformAppRelationList:this.platformAppRelationList,platformAppContentList:this.platformAppContentList},method = "post";
            if(this.$route.query.id) params = {...this.form,id:this.$route.query.id,platformAppRelationList:this.platformAppRelationList,platformAppContentList:this.platformAppContentList}, method = "put";
              this.$refs[formName].validate((valid) => {  
                    this.$refs['ruleForm1'].validate((valid1) => {
                      this.$refs['ruleForm2'].validate((valid2) => {
                         if(valid){
                            if(valid1){
                             if(valid2){
                               if(this.form.payModel == 1 && this.form.payType == 2){
                               for (const key in appSkuList) {
                                if(!appSkuList[key].name || !appSkuList[key].originalPrice || !appSkuList[key].salePrice || !appSkuList[key].deadline){
                                  setTimeout( () => {this.$message.error('请补全第' + (parseInt(Number(key)) + 1) + '条规格信息')}, 10)
                                   return 
                                }
                               }
                               }
                              //  if(this.form.appImagesList.length == 0 && this.form.payType == 2) return this.$message.error('请上传商品图片')
                                               //防抖提交
                                      debounce(() => {
                                           this.commentBness(params,method)
                                        }, 500)
                             }else{
                          this.$util.Notifi('请填写或上传必填项','error','fa-exclamation-circle');
                        }
                            }else{
                          this.$util.Notifi('请填写或上传必填项','error','fa-exclamation-circle');
                        }
                        }else{
                          this.$util.Notifi('请填写或上传必填项','error','fa-exclamation-circle');
                        }
                      })
                    })
                    }) 
        },
             commentBness(params,method){
               this.loading = true
                editApplication(params,method)
                        .then(res => {
                           if(res.code == 0){
                            this.loading = false
                            if(!this.$route.query.id) this.$message.success('新增成功'); 
                           if(this.$route.query.id) this.$message.success('修改成功'); 
                          
                                setTimeout(() => {
                           this.$router.push("/Application")
                             }, 100);
                           }else{
                             this.loading = false
                            this.$message.error(res.msg)
                           }
                        })
                        .catch(err => {
                           this.loading = false
                        })
        },
        handlePreview(file) {
      },
           handleAvatarSuccess(res, file) {
        this.form.pic = res.data.url
        
        if(this.form.pic){
        this.uploadBoolean = true
         }
      },
         handleAvatarSuccess3(res, file) {
        this.form.logoUrl= res.data.url
        if(this.form.logoUrl){
        this.uploadBoolean1 = true
         }
      },
      // 上传前获取签名
          beforeUploadFun(file){
            let _self  = this 
            return new Promise((resolve,reject) =>{
                 policy()
            .then(res =>{
               if(res.code == 0){
                if(res.data){
              _self.uploadUrl = res.data.host
              _self.dataObj = {
                policy:res.data.policy,
                signature:res.data.signature,
                ossaccessKeyId:res.data.accessId,
                key:res.data.dir + file.uid + file.name,
                dir:res.data.dir,
                host:res.data.host,
                callback:res.data.callback
              }
              }else{
                _self.uploadUrl = this.$config.baseUrl + '/admin/sys-file/upload'
              }
             }else{
                this.$util.Notifi(res.msg,'error','fa-exclamation-circle');
             }
             resolve(true)
            })
            .catch(err =>{
               reject(false)
              console.log(err)
            })
            })
          },
          handleAvatarSuccess1(res,file){
            console.log(res)
            this.loadStatus = 'success'
            this.form.resourceUrl = res.data.fileId
             this.dowloadShow = false
          },
              handleAvatarSuccess2(res, file) {
        this.form.thumb = res.data.url
        
        if(this.form.thumb){
        this.uploadBoolean2 = true
         } 
      },
      handleRemove1(file, fileList){
      },
          uploadError(err,file){
            this.loadStatus = 'exception'                 
            console.log(err,file)
            if( err.code == 1){
             this.$message.error('文件上传失败，原因：' + err.msg)  
            }else{
              this.$message.error('上传出错') 
            }
          },
        // 图片放大
         oploadImgPre(type){
                if(type == 1) this.oploadDialogVisible = true
                if(type == 2) this.oploadDialogVisible1 = true
                if(type == 3) this.oploadDialogVisible2 = true
            },
             oploadImgDel(type){
              if(type == 1){
                this.form.pic = ''
                let _this= this
                setTimeout(function(){
                    _this.uploadBoolean = false
                },1000)
              }else if(type == 2){
                 this.form.logoUrl = ''
                let _this= this
                setTimeout(function(){
                    _this.uploadBoolean1 = false
                },1000)
              }else{
                 this.form.thumb = ''
                let _this= this
                setTimeout(function(){
                    _this.uploadBoolean2 = false
                },1000)
              }
            },
    },
    beforeDestroy() {
    window.onbeforeunload = null
},
}
</script>
<style lang="scss" scoped>
.proMask{
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,.6);
  position:  absolute;
  top: 0;
}
  .moreImg,.flex-w{
    max-width: 780px;
    flex-wrap: wrap;
  }
.el-price-table{
  margin-bottom: 20px;
  .table-label{
    width: 100px;
   text-align: right;
    vertical-align: middle;
    float: left;
    font-size: 14px;
    color: #606266;
    line-height: 40px;
    padding: 0 12px 0 0;
    box-sizing: border-box;
    position: relative;
  }
  // .table-label::before{
  //   content: "*";
  //   color: #f56c6c;
  //   margin-right: 4px;
  // }
}
.el-price-table1{
  .table-label::before{
    content: none !important;
  }
}

.moreImg_btn{
  width: 148px;
  position: relative;
  color: #fff;
  height: 30px;
  text-align: center;
  line-height: 30px;
  background: rgba(0,0,0,.6);
  border-radius: 0 0 6px 6px;
  cursor: pointer;
  margin: 0 8px 8px 0;
}
.moreTop{
  margin-top: -252px;
}
.moreTop1{
  margin-top: -270px;
}
.moreBot{
  margin-top: -105px;
}
.moreBot1{
    margin-top: -105px;
}
#editApp{
    position: relative;
        .posta{
        width: calc(100% - 240px);
        position: absolute;
        background-color: rgb(255, 255, 255);
    box-shadow: rgb(240 240 240) 1px -2px 8px;
    height: 60px;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    position: fixed;
    left: 240px;
    bottom: 60px;
    z-index: 6;
    padding-left: 0;
    }
    .edit-from{
        margin-bottom: 44px;
            .el-form{
            flex-wrap: wrap;
            margin-top: 20px;
         .el-form-item{
            width: 50%;
        .el-input,.el-cascader{
            width: 80%;
        }
        .el-select,.el-input-group{
            width: 80%;
        }
        .el-textarea{
            width: 50%;
        }
        }
         }
        .App-tab{
            margin: 20px 0;
            
        }
    }
     .forminfo{
        margin-top: -50px;

     }
     .AppContent{
        margin: 20px 0;
        margin-bottom: 100px;
        position: relative;
        .moreCanvas{
            margin-top: 60px;
        }
        .moreCanvas:first-child{
            margin-top: 0;
        }
           .el-select1{
                width: 80%;
            }
        .fl-le{
            width: 40%;
        }
        .fl-rt {
             width: 40%;
        padding-left: 30px;
      }
      .deletBtn{
        margin-left: 30px;
        height: 32px;
        line-height: 30px;
        font-size: 14px;
        padding: 0 16px;
        border-radius: 2px;
        font-family: inherit;
        border-width: 1px;
        border-style: solid;
        text-align: center;
        vertical-align: middle;
        box-sizing: border-box;
        cursor: pointer;
        transition: all 0.3s;
        background: #f56c6c;
        color: #fff;
      }
      .el-input,.el-cascader{
            width: 100%;
        }
     }
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="10px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="10px"]::before {
  content: "10px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="12px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="12px"]::before {
  content: "12px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="14px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="14px"]::before {
  content: "14px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="16px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="16px"]::before {
  content: "16px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="18px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="18px"]::before {
  content: "18px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="20px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="20px"]::before {
  content: "20px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="22px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="22px"]::before {
  content: "22px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="24px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="24px"]::before {
  content: "24px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="26px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="26px"]::before {
  content: "26px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="28px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="28px"]::before {
  content: "28px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="30px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="30px"]::before {
  content: "30px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="32px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="32px"]::before {
  content: "32px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="36px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="36px"]::before {
  content: "36px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="38px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="38px"]::before {
  content: "38px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="40px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="40px"]::before {
  content: "40px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="45px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="45px"]::before {
  content: "45px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="50px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="50px"]::before {
  content: "50px";
}
/**
设置默认字体显示
设置默认字体颜色
**/
.ql-container {
  font-size: 16px;
  color: black;
}
.btn-onsubmit {
  margin-top: 50px;
  text-align: center;
}
.btn-onsubmit .el-button {
  width: 30%;
}
.editor {
  line-height: normal !important;
  width: 100%;
  margin: 0 auto;
 margin-top: 20px;
 height: 400px;
}
.ql-container {
  height: calc(100vh - 350px) !important;
}

.ql-snow .ql-tooltip[data-mode="link"]::before {
  content: "请输入链接地址:";
}
.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
  border-right: 0px;
  content: "保存";
  padding-right: 0px;
}

.ql-snow .ql-tooltip[data-mode="video"]::before {
  content: "请输入视频地址:";
}

.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
  content: "14px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="small"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="small"]::before {
  content: "10px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="large"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="large"]::before {
  content: "18px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="huge"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="huge"]::before {
  content: "32px";
}

.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
  content: "文本";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
  content: "标题1";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
  content: "标题2";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
  content: "标题3";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
  content: "标题4";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
  content: "标题5";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
  content: "标题6";
}

.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
  content: "标准字体";
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="serif"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="serif"]::before {
  content: "衬线字体";
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="monospace"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="monospace"]::before {
  content: "等宽字体";
}
  ::v-deep{
        .ql-snow .ql-tooltip {
    left: 0 !important;
}
.ql-video{
    width: 100%;

}
 .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 180px;
    height: 180px;
    line-height: 180px;
    text-align: center;
  }
  .avatar-uploaderlogo{
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 80px;
        height: 80px;
        line-height: 80px;
        text-align: center;
    }
    .avatar {
    width: 80px;
    height: 80px;
    display: block;
  }
  }
  .avatar {
    width: 180px;
    height: 180px;
    display: block;
  }
  .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 180px;
        height: 180px;
        line-height: 180px;
        text-align: center;
    }
   .upload-icon {
        position: absolute;
        top: 50%;
        margin-left: -28px;
        margin-top: -18px;
    }
    .el-dialog{
        width: 30%;
    }
    .el-list-enter-active,.el-list-leave-active{
        transition: none;
    }
    .el-list-enter,.el-list-leave-active {
      opacity: 0;
    }
    .el-upload-list {
      height: 40px;
    }
  }
</style>